<section class="section-div">
  <div class="header-div">
    <h4>
      <ion-icon name="business-outline"></ion-icon> Management Strategy -
      {{ incubaterName }}
    </h4>
  </div>
  <div class="content-details">
    <div class="content-div mb-2">
      <div class="d-flex" *ngIf="mobileQuery.matches == false">
        <h5 class="mb-3">Questions</h5>
      </div>

      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-12">
          <mat-accordion>
            <!-- qusetion 001 -->
            <mat-expansion-panel [expanded]="step === 0" (opened)="setStep(0)">
              <mat-expansion-panel-header class="d-flex">
                <h6>01.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Vision and Mission Statement of the Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.missionVisionStatus)"
                    [style.background]="pickColor(getValue.missionVisionStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.missionVisionStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Vision and Mission Statement of the Incubation Centre</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.missionVisionIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.missionVisionIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{ getValue.missionVisionUrlIcWebsite }}"
                                target="_blank"
                                >{{ getValue.missionVisionUrlIcWebsite }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.missionVisionDocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.missionVisionStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.missionVisionReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[0])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.missionVisionStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('missionVisionStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('missionVisionStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.missionVisionStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('missionVisionStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 002 -->
            <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)">
              <mat-expansion-panel-header class="d-flex">
                <h6>02.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Standard Operating Procedure for the Incubation Centre
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.standardoperatingStatus)"
                    [style.background]="
                      pickColor(getValue.standardoperatingStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.standardoperatingStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Standard Operating Procedure for the Incubation Centre
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.standardoperatingIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.standardoperatingIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.standardoperatingdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.standardoperatingStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.standardoperatingReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[1])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.standardoperatingStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('standardoperatingStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('standardoperatingStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.standardoperatingStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('standardoperatingStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 003 -->
            <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)">
              <mat-expansion-panel-header class="d-flex">
                <h6>03.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Short-term / Mid-term / Long-term goals established in
                    connection with Sustainability
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.shortMidLongStatus)"
                    [style.background]="pickColor(getValue.shortMidLongStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.shortMidLongStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Short-term / Mid-term / Long-term goals established in
                    connection with Sustainability
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.shortMidLongIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.shortMidLongIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.shortMidLongdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.shortMidLongdStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.shortMidLongdReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[2])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.shortMidLongStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('shortMidLongStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('shortMidLongStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.shortMidLongStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('shortMidLongStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 004 -->
            <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
              <mat-expansion-panel-header class="d-flex">
                <h6>04.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Availability of an Advisory Board / Governance Body and
                    Project Management Committee (PMC)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.projectmanagementcommitteeStatus)
                    "
                    [style.background]="
                      pickColor(getValue.projectmanagementcommitteeStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.projectmanagementcommitteeStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Availability of an Advisory Board / Governance Body and
                    Project Management Committee
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.projectmanagementcommitteeIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{
                              getValue.projectmanagementcommitteeIncCentre
                            }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">
                            URL from Incubation Center Website
                          </p>
                          <ul class="web-ul">
                            <li>
                              <a
                                href="{{
                                  getValue.projectmanagementcommitteeUrlIcWebsite
                                }}"
                                target="_blank"
                                >{{
                                  getValue.projectmanagementcommitteeUrlIcWebsite
                                }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.projectmanagementcommitteedocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.projectmanagementcommitteeStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.projectmanagementcommitteeReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[3])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.projectmanagementcommitteeStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="
                          approveBtn('projectmanagementcommitteeStatus', 4)
                        "
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="
                          reviewBtn('projectmanagementcommitteeStatus', 3)
                        "
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.projectmanagementcommitteeStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="
                          rejectBtn('projectmanagementcommitteeStatus', 6)
                        "
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 005 -->
            <mat-expansion-panel [expanded]="step === 4" (opened)="setStep(4)">
              <mat-expansion-panel-header class="d-flex">
                <h6>05.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Board meetings conducted (Minimum two)
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.boardmeetingsStatus)"
                    [style.background]="pickColor(getValue.boardmeetingsStatus)"
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.boardmeetingsStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Board meetings conducted (Minimum two)</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.boardmeetingsIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.boardmeetingsIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.boardmeetingsdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.boardmeetingsStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.boardmeetingsReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[4])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.boardmeetingsStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('boardmeetingsStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('boardmeetingsStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.boardmeetingsStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('boardmeetingsStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 006 -->
            <mat-expansion-panel [expanded]="step === 5" (opened)="setStep(5)">
              <mat-expansion-panel-header class="d-flex">
                <h6>06.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Quaterly review meetings with the Board / PMC
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="pickWidth(getValue.quaterlyreviewStatus)"
                    [style.background]="
                      pickColor(getValue.quaterlyreviewStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="innerValue(getValue.quaterlyreviewStatus)"
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Quaterly review meetings with the Board / PMC</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.quaterlyreviewIncCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.quaterlyreviewIncCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.quaterlyreviewdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.quaterlyreviewStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.quaterlyreviewReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[5])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.quaterlyreviewStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('quaterlyreviewStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('quaterlyreviewStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.quaterlyreviewStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('quaterlyreviewStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 6" (opened)="setStep(6)">
              <mat-expansion-panel-header class="d-flex">
                <h6>07.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Enterprise Resource Planning / Project Management Tools
                    utilized
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.enterpriceresourceplanStatus)
                    "
                    [style.background]="
                      pickColor(getValue.enterpriceresourceplanStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.enterpriceresourceplanStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>
                    Enterprise Resource Planning / Project Management Tools
                    utilized
                  </h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.enterpriceresourceplanCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.enterpriceresourceplanCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.enterpriceresourceplandocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.enterpriceresourceplanStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.enterpriceresourceplanReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[6])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.enterpriceresourceplanStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('enterpriceresourceplanStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('enterpriceresourceplanStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.enterpriceresourceplanStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('enterpriceresourceplanStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
                <button mat-button color="primary" (click)="nextStep()">
                  Next
                </button>
              </mat-action-row>
            </mat-expansion-panel>
            <!-- qusetion 007 -->
            <mat-expansion-panel [expanded]="step === 7" (opened)="setStep(7)">
              <mat-expansion-panel-header class="d-flex">
                <h6>08.&nbsp;</h6>
                <h6>
                  <span *ngIf="mobileQuery.matches == false">
                    Roles of the Management Team
                  </span>
                  <span *ngIf="mobileQuery.matches == true">Question</span>
                </h6>
                <div class="success-span ml-auto">
                  <div
                    class="set success"
                    [style.width]="
                      pickWidth(getValue.rolemanangementteamStatus)
                    "
                    [style.background]="
                      pickColor(getValue.rolemanangementteamStatus)
                    "
                  >
                    <svg
                      version="1.1"
                      id="check"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      xml:space="preserve"
                    >
                      <circle
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-miterlimit: 10;
                        "
                        cx="49.799"
                        cy="49.746"
                        r="44.757"
                      />
                      <polyline
                        style="
                          fill: rgba(0, 0, 0, 0);
                          stroke: #ffffff;
                          stroke-width: 10;
                          stroke-linecap: round;
                          stroke-linejoin: round;
                          stroke-miterlimit: 10;
                        "
                        points="
                                                27.114,51 41.402,65.288 72.485,34.205 "
                      />
                    </svg>
                    <span
                      [innerHTML]="
                        innerValue(getValue.rolemanangementteamStatus)
                      "
                    ></span>
                  </div>
                </div>
              </mat-expansion-panel-header>
              <div class="row">
                <div class="col-12 mb-2" *ngIf="mobileQuery.matches == true">
                  <h6>Roles of the Management Team</h6>
                </div>
              </div>
              <div
                class="answer-div"
                *ngIf="getValue.rolemanangementteamCentre == 'Yes'"
              >
                <div class="row">
                  <div class="col-lg-8 col-md-8 col-sm-12 col-12">
                    <div class="submitted-details">
                      <div class="submiited-header">
                        <div class="name-header d-flex">
                          <span class="material-icons">fact_check</span>
                          <span class="ml-1">Submitted Details :</span>
                        </div>
                      </div>
                      <div class="submitted-content">
                        <div class="sub-div">
                          <p class="p-lbl">
                            Option Selected :
                            <b>{{ getValue.rolemanangementteamCentre }}</b>
                          </p>
                        </div>
                        <div class="sub-div">
                          <p class="p-lbl">Supporting Documents</p>
                          <ul class="sub-ul">
                            <li
                              *ngFor="
                                let list of getValue.rolemanangementteamdocuments
                              "
                            >
                              <a
                                href="{{ list.documentName }}"
                                target="_blank"
                                >{{ list.documentName }}</a
                              >
                            </li>
                          </ul>
                        </div>
                        <div
                          class="sub-div"
                          *ngIf="getValue.rolemanangementteamStatus == 3"
                        >
                          <p class="p-lbl">Reason for clarification</p>
                          <p class="c-black comments">
                            {{ getValue.rolemanangementteamReason }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-4 col-12">
                    <div
                      class="guideline-div d-flex"
                      (click)="guidelinesBtn(guidelineValue[7])"
                    >
                      <span class="material-icons">description</span>
                      <span class="ml-1">Guidelines</span>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="3 > getValue.rolemanangementteamStatus"
                    >
                      <button
                        class="custom-btn btn-14 mr-3"
                        (click)="approveBtn('rolemanangementteamStatus', 4)"
                      >
                        Approve
                        <div class="dot"></div>
                      </button>
                      <button
                        class="custom-btn btn-13"
                        (click)="reviewBtn('rolemanangementteamStatus', 3)"
                      >
                        Review
                      </button>
                    </div>
                    <div
                      class="col-12 text-center mt-3"
                      *ngIf="getValue.rolemanangementteamStatus == 3"
                    >
                      <button
                        class="custom-btn btn-5"
                        (click)="rejectBtn('rolemanangementteamStatus', 6)"
                      >
                        Reject
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <mat-action-row>
                <button mat-button color="accent" (click)="prevStep()">
                  Previous
                </button>
              </mat-action-row>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </div>
    </div>
  </div>
</section>
